import { createGlobalStyle } from 'styled-components';
import { theme } from 'constants/styled-theme';

const GlobalStyle = createGlobalStyle`

.registrationPaymentFaildModal {
    .ReactModal__Content {  
      width: 770px;
      height: 257px;
      padding-top: 91px;
    }
  }

.registrationPaymentFormModal {
    .ReactModal__Content {  
      width: 770px;
      height: 500px;
    }
  }

  .subscriptionAssociatedModal {
    .ReactModal__Content {
      width: 675px;
  }
}

.ReactModal__Overlay.modalOverlay {
    background: rgba(0, 0, 0, 0.4);
}

`;

export default GlobalStyle;
